var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFolderProcess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0882 5.27332L11.2362 5.5H11.5069H20C20.8284 5.5 21.5 6.17157 21.5 7V18C21.5 18.8284 20.8284 19.5 20 19.5H4C3.17157 19.5 2.5 18.8284 2.5 18V5C2.5 4.17157 3.17157 3.5 4 3.5H9.93058L11.0882 5.27332Z",
    fill: "#CDD0D4",
    stroke: "#74797D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4475 13.698V17H8.90332V8.11328H12.303C13.2958 8.11328 14.0832 8.37166 14.665 8.88843C15.251 9.40519 15.5439 10.0888 15.5439 10.9392C15.5439 11.81 15.2571 12.4875 14.6833 12.9717C14.1137 13.4559 13.3141 13.698 12.2847 13.698H10.4475ZM10.4475 12.459H12.303C12.8523 12.459 13.2714 12.3308 13.5603 12.0745C13.8492 11.814 13.9937 11.4397 13.9937 10.9514C13.9937 10.4713 13.8472 10.0888 13.5542 9.80396C13.2612 9.51506 12.8584 9.36654 12.3457 9.3584H10.4475V12.459Z",
    fill: "#74797D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderProcess);
export default __webpack_public_path__ + "static/media/folder-process.c3918ca2b934a0022654c194863ab36c.svg";
export { ForwardRef as ReactComponent };